import React, { Component } from "react";
import { Input, Table, Row, Col, FormGroup, Label, Form } from "reactstrap";
import ReactGA from "react-ga4";
import * as message from "../../Constants/MessageConstant";
import {
  ColumnSeries,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  StackingBarSeries,
  Chart,
} from "@syncfusion/ej2-react-charts";
import { priceDisplay } from "../../Constants/CommonConstant";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import jstz from "jstz";

String.prototype.toHHMM = function () {
  var sec_num = parseInt(this, 10); // don't forget the second param
  var mm = "00";
  var hh = sec_num;
  if (sec_num < 9) {
    hh = "0" + sec_num;
  }
  return hh + ":" + mm;
};

class ParkingPdf extends Component {
  constructor(props) {
    super(props);
    this.dayFound = this.dayFound.bind(this);

    this.state = {
      providerName: "",
      loggedInUser: "",
      currentDateTime: 0,
      value: undefined,
      reportDataPayload:
        this.props.location.state.data !== undefined
          ? this.props.location.state.data
          : [],
      modalLoader: false,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: false,
      isFreeTrial: false,
      tzAbbr: "",
      chartLeftImage: "",
      chartRightImage: "",
      turnOffDaysAr: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      resourceTypePalette: [
        "#C8FFFF",
        "#007FFF",
        "#C8C8C8",
        "#646464",
        "#3200FF",
        "#00007F",
      ],
      costPalett: ["#C4C3C3", "#2500A1"],
      legendSettings: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          size: window.innerWidth < 767 ? "14px" : "20px",
          fontFamily: "Poppins, sans-serif",
        },
        alignment: "Center",
        toggleVisibility: false,
      },
      legendSettingsProcess: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          size: window.innerWidth < 767 ? "14px" : "24px",
          fontFamily: "Poppins, sans-serif",
        },
        alignment: "Center",
        toggleVisibility: false,
      },
      titleStyle: {
        color: "#393939",
        size: "16px",
        fontWeight: "bold",
        location: { x: "277", y: "26.5" },
      },
      marker: {
        dataLabel: {
          position: "Auto",
          visible: true,
          font: {
            color: "white",
            size: "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costPerfMarker: {
        dataLabel: {
          position: "Outer",
          visible: true,
          font: {
            color: "#393939",
            size: window.innerWidth < 767 ? "16px" : "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "0",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      costyAxis: {
        title: "Monthly Cost Run Rate",
        labelStyle: {
          size: "20px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: window.innerWidth < 767 ? "14px" : "20px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
      },
      chartTitleStyle: {
        color: "#393939",
        fontWeight: "500",
        size: "17px",
        fontFamily: "Poppins, sans-serif",
      },
      progressxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      progressyAxis: {
        labelFormat: "{value}%",
        minimum: 0,
        maximum: 100,
        interval: 25,
        labelStyle: { size: "20px", fontFamily: "Poppins, sans-serif" },
      },
    };
  }

  async componentDidMount() {
    await this.setState({ modalLoader: true });

    let responseJson = this.props.clientSidePdfData;
    if (responseJson) {
      if (responseJson.success === true && responseJson.data !== undefined) {
        await this.setState({
          providerName: responseJson.orgInfo.providerName,
        });
        if (
          responseJson.data.costGraph !== undefined &&
          responseJson.data.costGraph.costChart !== undefined
        ) {
          let mxCost = Math.max.apply(
            Math,
            responseJson.data.costGraph.costChart.map(function (o) {
              return o.current_cost;
            })
          );
          let interval = Math.round(mxCost / 4);

          await this.setState({
            costyAxis: {
              interval: interval,
              maximum: mxCost + interval,
              minimum: 0,
            },
          });
        }

        //      Progress Chart
        let order = {
          percent_unanalyzed: "#6848D2",
          percent_analyzed: "#2500A1",
          percent_analysis_ineligible: "#D9CEFF",
          percent_analysis_error: "#A489FF",
          percent_optimized: "#00A17A",
          percent_custom_sized: "#26DAAE",
        };

        let label = {
          percent_unanalyzed: "Unanalyzed",
          percent_analyzed: "Analyzed",
          percent_analysis_ineligible: "Analysis Ineligible",
          percent_analysis_error: "Analysis Issue",
          percent_optimized: "Parked",
          percent_custom_sized: "Parked",
        };

        let keysSorted = Object.keys(
          responseJson.data.progressGraph.progressList[0]
        ).sort((a, b) => {
          return Object.keys(order).indexOf(a) - Object.keys(order).indexOf(b);
        });
        let fiterData = [];
        let data = responseJson.data.progressGraph.progressList[0];

        keysSorted.map((value) => {
          if (
            parseInt(data[value]) !== 0 &&
            data[value] !== null &&
            value.startsWith("percent_")
          ) {
            let obj1 = {
              type: "StackingBar",
              dataSource: [
                {
                  resourceName: data.resourceName,
                  [value]: data[value],
                  [`actual_${value}`]: data[`actual_${value}`],
                },
              ],
              xName: "resourceName",
              yName: value,
              name: label[value],
              legendShape: "Rectangle",
              fill: order[value],
              marker: {
                dataLabel: {
                  visible: true,
                  font: { size: "22px", fontFamily: " Poppins, sans-serif" },
                },
              },
            };
            fiterData.push(obj1);
          }
        });

        Chart.Inject(
          Chart,
          StackingBarSeries,
          Category,
          Tooltip,
          Legend,
          DataLabel
        );

        let chart = new Chart({
          //Initializing Primary X Axis
          primaryXAxis: {
            valueType: "Category",
            labelStyle: {
              size: window.innerWidth < 767 ? "14px" : "22px",
              fontWeight: "500",
              color: "#808080",
              fontFamily: "Poppins, sans-serif",
            },
          },
          //Initializing Primary Y Axis
          primaryYAxis: {
            minimum: 0,
            maximum: 100,
            interval: 25,
            labelStyle: {
              size: window.innerWidth < 767 ? "14px" : "22px",
              fontWeight: "400",
              color: "#393939",
              fontFamily: "Poppins, sans-serif",
            },
            labelFormat: "{value}%",
          },
          chartArea: {
            border: {
              width: 1,
            },
          },
          series: fiterData,
          legendSettings: this.state.legendSettingsProcess,
          height: "300",
          title: "",
          titleStyle: this.state.chartTitleStyle,
          palettes: this.state.resourceTypePalette,
          pointRender: this.progressBarPointRenderer,
          axisLabelRender: this.axisLabelRender,
          marker: this.state.marker,
        });
        chart.appendTo("#renderProgressChart");

        //     End Progress Chart

        await this.setState({
          value: responseJson.data,
          modalLoader: false,
          isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
          currentDateTime: responseJson.orgInfo.currentDateTime,
          loggedInUser: responseJson.orgInfo.loggedInUser,
        });
      }
    }
  }

  axisLabelRender = (args) => {
    if (!isNaN(args.value) && !isNaN(args.axis.endLabel)) {
      args.text = "";
    }
  };

  axisPointRender = (args) => {
    //        if (args.point.y == 0) {
    //            args.cancel = true;
    //        } else {
    args.point.y = parseFloat(args.point.y).toFixed(2);
    args.point.text = priceDisplay(
      args.point.y,
      this.state.value?.userCurrency
    );
    //}
  };

  progressBarPointRenderer = (args) => {
    //console.log(args);
    if (args.point.y == 0) {
      args.cancel = true;
    } else {
      var text = "actual_" + args.series.properties.yName;
      if (
        args.series.properties.dataSource[0][text] !== undefined &&
        args.series.properties.dataSource[0][text] !== null
      ) {
        args.point.yValue = args.series.properties.dataSource[0][text];
      }
    }
  };

  dayFound(day) {
    if (this.state.currentDs !== undefined) {
      if (
        this.state.currentDs.turnOffDaysOfWeek !== undefined &&
        this.state.currentDs.turnOffDaysOfWeek !== null
      ) {
        var days_ar = this.state.currentDs.turnOffDaysOfWeek.split(",");
        var found = days_ar.some((d) =>
          d.toLowerCase().trim().startsWith(day.toLowerCase().trim())
        );
        return found;
      }
    }
    return false;
  }

  render() {
    return (
      <div>
        <div
          className="container-verf container-verf-padding"
          role="main"
          id="fillme"
          style={{ marginTop: "50px" }}
        >
          <div className="container1 boxShadow">
            <div
              id="list_account"
              style={{ width: "100%", justifyContent: "space-between" }}
            >
              <div
                className="reportChart"
                style={{ padding: "0px", width: "100%", paddingBottom: "40px" }}
              >
                <div id="parkingLeftChart">
                  <Row
                    id="parkingCostChart"
                    style={{ justifyContent: "center" }}
                  >
                    <Col sm="8">
                      <ChartComponent
                        id="parkingcchart"
                        axisLabelRender={this.axisLabelRender}
                        pointRender={this.axisPointRender}
                        primaryXAxis={this.state.costxAxis}
                        primaryYAxis={this.state.costyAxis}
                        title=""
                        titleStyle={this.state.chartTitleStyle}
                        palettes={this.state.costPalett}
                        legendSettings={this.state.legendSettings}
                      >
                        <Inject
                          services={[ColumnSeries, Legend, DataLabel, Category]}
                        />
                        <SeriesCollectionDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="current_cost"
                            name="Original Cost"
                            type="Column"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="reduced_cost"
                            name="Post-Parking Cost"
                            type="Column"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                        </SeriesCollectionDirective>
                      </ChartComponent>
                    </Col>
                  </Row>

                  <Row
                    id="parkingProgressChart"
                    style={{ justifyContent: "center" }}
                  >
                    <Col sm="9">
                      <div id="renderProgressChart"></div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.value &&
          this.state.value.resultList.map((vm, i) => {
            let turnOffHoursList = vm.turnOffHoursList;
            let turnOffDaysOfWeek = vm.turnOffDaysOfWeek;
            var isParkingSuggested = false;
            if (
              turnOffDaysOfWeek !== undefined &&
              turnOffDaysOfWeek !== null &&
              turnOffDaysOfWeek !== ""
            ) {
              isParkingSuggested = true;
            }
            if (
              turnOffHoursList !== null &&
              turnOffHoursList !== undefined &&
              turnOffHoursList.length > 0
            ) {
              isParkingSuggested = true;
            }
            // var tzStr = vm.userGmtId + " (" + vm.userTimeZoneName + ")";
            var dateObject = new Date(),
              dateString = dateObject + "",
              tzAbr =
                dateString.match(/\(([^\)]+)\)$/) ||
                dateString.match(/([A-Z]+) [\d]{4}$/);

            if (tzAbr) {
              tzAbr = tzAbr[1].match(/[A-Z]/g).join("");
            }
            var tz = jstz.determine().name();
            tzAbr = tzAbr + " (" + tz + ")";

            return isParkingSuggested ? (
              <div
                className="container-verf container-verf-padding"
                id={`parkingSchedule${i + 1}`}
              >
                <div
                  style={{
                    textAlign: "center",
                    display: "grid",
                    justifyContent: "center",
                  }}
                >
                  <Row>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      <img
                        style={{ height: "72px", width: "72px" }}
                        src={require("../../images/VMParkingIcon_01.svg")}
                        alt=""
                      />
                    </div>
                  </Row>
                  {turnOffDaysOfWeek !== undefined &&
                  turnOffDaysOfWeek !== null &&
                  turnOffDaysOfWeek !== "" ? (
                    <Row
                      style={{
                        paddingBottom: "20px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      <Row style={{ fontWeight: "501", fontSize: "20px" }}>
                        Parking Days All Hours :
                      </Row>
                      <Row>
                        <Form style={{ marginTop: "10px" }} inline>
                          {this.state.turnOffDaysAr.map((d, i) => {
                            return (
                              <FormGroup style={{ marginRight: "20px" }}>
                                <Label
                                  style={{
                                    color: this.dayFound(d)
                                      ? "#03A9C4"
                                      : "grey",
                                  }}
                                  check
                                >
                                  {this.dayFound(d) ? (
                                    <Input
                                      type="checkbox"
                                      checked={true}
                                      disabled
                                    />
                                  ) : null}
                                  {d}
                                </Label>
                              </FormGroup>
                            );
                          })}
                        </Form>
                      </Row>
                    </Row>
                  ) : null}
                  {turnOffHoursList !== undefined &&
                  turnOffHoursList !== null &&
                  turnOffHoursList.length > 0 ? (
                    <Row style={{ paddingTop: "20px" }}>
                      <Row style={{ fontWeight: "501", fontSize: "20px" }}>
                        Parking Hours Every Day :
                      </Row>
                      <Table borderless>
                        {turnOffHoursList.map((hrs, i) => {
                          return (
                            <tr>
                              <td style={{ width: "8px" }}>
                                <div style={{ paddingTop: "10px" }}>From</div>
                              </td>
                              <td style={{ width: "20%" }}>
                                <Input
                                  style={{
                                    backgroundColor: "white",
                                    border: "1px solid #03A9C4",
                                    color: "#03A9C4",
                                    width: "70px",
                                  }}
                                  type="text"
                                  name="city"
                                  id="from"
                                  value={hrs.from}
                                  disabled
                                />
                              </td>
                              <td style={{ width: "5px" }}>
                                <div style={{ paddingTop: "10px" }}>To</div>
                              </td>
                              <td>
                                <Input
                                  style={{
                                    backgroundColor: "white",
                                    border: "1px solid #03A9C4",
                                    width: "70px",
                                    color: "#03A9C4",
                                  }}
                                  type="text"
                                  name="city"
                                  id="to"
                                  value={hrs.to}
                                  disabled
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </Table>
                    </Row>
                  ) : null}
                  <Row style={{ fontSize: "18px", paddingTop: "25px" }}>
                    All times in {"\u00A0"}
                    <b>{tzAbr}</b>
                    {"\u00A0"} timezone{" "}
                  </Row>
                </div>
              </div>
            ) : null;
          })}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

export default connect(mapStateToProps, null)(withRouter(ParkingPdf));
